<template>
	<div style="background-color: #fff;width: 100vw;height: 100vh;">
		<Header :isHome="false"></Header>
		<div class="container" style="padding: 7rem 0 10rem;">
			<div class="row" style="justify-content: center;">
				<div style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
					<img src="../../assets/imgs/user/userlevel/paysuccess.png" style="width: 15rem;height: 15rem;">
					<div style="margin-top: 0.5rem;font-size: 1.5rem;">
						Payment successful
					</div>
					<div class="btn-cyan-liner" style="padding: 0.5rem 1.5rem;margin-top: 2rem;border-radius: 5rem;cursor: pointer;font-size: 1rem;font-weight: 500;" @click="touserlevel">Enter member</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
		import Header from '/src/components/header.vue'
		import Footer from '/src/components/footer.vue'
		export default {
			data() {
				return {
				}
			},
			components: {
				Header,
				Footer
			},
			methods: {
				touserlevel(){
					this.$router.push({name:'userlevel'})
				}
			},
			mounted() {
			}
		}
</script>

<style scoped lang="scss">
</style>